import { FilterType, Filter, FilterKey } from 'api-paths-cas';
import { IGetFilterGroupsProps } from '../types';

import { FundsMaturitySelection } from './types';

const FundsMaturityOptions = [
  {
    label: 'Approved',
    value: FundsMaturitySelection.APPROVED,
  },
  {
    label: 'Matured (Verified)',
    value: FundsMaturitySelection.MATURED_VERIFIED,
  },
  {
    label: 'Matured (Unverified)',
    value: FundsMaturitySelection.MATURED_UNVERIFIED,
  },
  {
    label: 'Insufficient',
    value: FundsMaturitySelection.INSUFFICIENT,
  },
  {
    label: 'Not matured (Date)',
    value: FundsMaturitySelection.NOT_MATURED_DATE,
  },
  {
    label: 'N/A',
    value: FundsMaturitySelection.N_A,
  },
  {
    label: 'Other',
    value: FundsMaturitySelection.OTHER,
  },
];

const key = FilterKey.FUNDS_MATURITY;
export const getFundsMaturityFilter = ({ activeFilters }: IGetFilterGroupsProps): Filter => {
  const filters = activeFilters[key] ?? [];
  const options = FundsMaturityOptions.map(({ label, value }) => {
    return {
      label,
      value,
      checked: filters.some(filter => filter === value),
    };
  });
  return {
    name: 'Funds maturity',
    key,
    type: FilterType.SELECT_MANY,
    showSearch: false,
    options: {
      SELECT_MANY: options,
    },
  };
};
